import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { driverToString } from "src/services/driver/driver.interface";
import { ItemHistoryService } from "src/services/history/item-history.service";
import { LoadingService } from "src/services/loading/loading.service";
import { UserApiService } from "src/services/user/user-api.service";
import { BaseHistoryListComponent } from "../base-history-list.component";

@Component({
  selector: "rc-item-history-list",
  templateUrl: "../base-history-list.component.html",
  styleUrls: ["../base-history-list.component.scss"],
  standalone: false,
})
export class ItemHistoryListComponent extends BaseHistoryListComponent implements OnChanges {
  @Input() public itemId: string;

  constructor(
    protected readonly userService: UserApiService,
    private readonly itemHistoryService: ItemHistoryService,
    private readonly loadingService: LoadingService,
  ) {
    super(userService);
  }

  public async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.itemId && this.itemId) {
      await this.initData();
    }
  }

  protected async initData(): Promise<void> {
    if (!this.itemId) {
      return;
    }
    this.loading = true;
    await this.loadingService.wrapInLoading(async () => {
      this.historyLogs = await this.itemHistoryService.getHistoryByItemId(this.itemId);
      await this.populateUsers(this.historyLogs.map((log) => log.user.userId));
      this.populateIcons();
      this.loading = false;
      this.loaded = true;
    });
  }

  private populateIcons(): void {
    for (const log of this.historyLogs) {
      switch (log.action) {
        case "createItem":
          log.icon = "add-circle-outline";
          break;
        case "updateCategory":
          log.icon = "pricetag-outline";
          break;
        case "updateLocation":
          log.icon = "pin-outline";
          break;
        case "updateStatus":
          log.icon = "attach-outline";
          break;
      }
    }
  }

  public readonly driverToString = driverToString;
}
